"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_state_1 = require("prosemirror-state");

var prosemirror_tables_1 = require("prosemirror-tables");

var prosemirror_commands_1 = require("prosemirror-commands");

var Extension_1 = __importDefault(require("../lib/Extension"));

var isUrl_1 = __importDefault(require("../lib/isUrl"));

var isMarkdown_1 = __importDefault(require("../lib/isMarkdown"));

var isInCode_1 = __importDefault(require("../queries/isInCode"));

var Prism_1 = require("./Prism");

function normalizePastedMarkdown(text) {
  var CHECKBOX_REGEX = /^\s?(\[(X|\s|_|-)\]\s(.*)?)/gim;

  while (text.match(CHECKBOX_REGEX)) {
    text = text.replace(CHECKBOX_REGEX, function (match) {
      return "- ".concat(match.trim());
    });
  }

  return text;
}

var PasteHandler =
/*#__PURE__*/
function (_Extension_1$default) {
  _inherits(PasteHandler, _Extension_1$default);

  function PasteHandler() {
    _classCallCheck(this, PasteHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(PasteHandler).apply(this, arguments));
  }

  _createClass(PasteHandler, [{
    key: "name",
    get: function get() {
      return "markdown-paste";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          handlePaste: function handlePaste(view, event) {
            if (view.props.editable && !view.props.editable(view.state)) {
              return false;
            }

            if (!event.clipboardData) return false;
            var text = event.clipboardData.getData("text/plain");
            var html = event.clipboardData.getData("text/html");
            var vscode = event.clipboardData.getData("vscode-editor-data");
            var state = view.state,
                dispatch = view.dispatch;

            if (isUrl_1.default(text)) {
              if (!state.selection.empty) {
                prosemirror_commands_1.toggleMark(_this.editor.schema.marks.link, {
                  href: text
                })(state, dispatch);
                return true;
              }

              var embeds = _this.editor.props.embeds;

              if (embeds && !prosemirror_tables_1.isInTable(state)) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = embeds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var embed = _step.value;
                    var matches = embed.matcher(text);

                    if (matches) {
                      _this.editor.commands.embed({
                        href: text
                      });

                      return true;
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }

              var transaction = view.state.tr.insertText(text, state.selection.from, state.selection.to).addMark(state.selection.from, state.selection.to + text.length, state.schema.marks.link.create({
                href: text
              }));
              view.dispatch(transaction);
              return true;
            }

            if (isInCode_1.default(view.state)) {
              event.preventDefault();
              view.dispatch(view.state.tr.insertText(text));
              return true;
            }

            var vscodeMeta = vscode ? JSON.parse(vscode) : undefined;
            var pasteCodeLanguage = vscodeMeta === null || vscodeMeta === void 0 ? void 0 : vscodeMeta.mode;

            if (pasteCodeLanguage && pasteCodeLanguage !== "markdown") {
              event.preventDefault();
              view.dispatch(view.state.tr.replaceSelectionWith(view.state.schema.nodes.code_fence.create({
                language: Object.keys(Prism_1.LANGUAGES).includes(vscodeMeta.mode) ? vscodeMeta.mode : null
              })).insertText(text));
              return true;
            }

            if (html === null || html === void 0 ? void 0 : html.includes("data-pm-slice")) {
              return false;
            }

            if (isMarkdown_1.default(text) || html.length === 0 || pasteCodeLanguage === "markdown") {
              event.preventDefault();

              var paste = _this.editor.pasteParser.parse(normalizePastedMarkdown(text));

              var slice = paste.slice(0);

              var _transaction = view.state.tr.replaceSelection(slice);

              view.dispatch(_transaction);
              return true;
            }

            return false;
          }
        }
      })];
    }
  }]);

  return PasteHandler;
}(Extension_1.default);

exports.default = PasteHandler;